import { Avatar, type AvatarProps } from '@mui/material'

interface UserAvatarProps extends Omit<AvatarProps, 'src' | 'children'> {
  name?: string | null
  avatarUrl?: string | null
  size?: number
}

function getInitials(name: string | null | undefined): string {
  if (!name) return '?'
  return name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2)
}

export function UserAvatar({ name, avatarUrl, size = 32, sx, ...rest }: UserAvatarProps) {
  const initials = getInitials(name)
  const fontSize = size <= 22 ? 9 : size <= 28 ? 10 : size <= 36 ? 12 : size <= 48 ? 16 : 22

  return (
    <Avatar
      src={avatarUrl ?? undefined}
      sx={{
        width: size, height: size,
        fontSize, fontWeight: 700,
        ...sx,
      }}
      {...rest}
    >
      {initials}
    </Avatar>
  )
}
